/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_Blocked_Edge_2Inputs */



/**
* | output |
* | --- |
* | "Set Microphone to Allow." |
*
* @param {Practice_Session_Mic_Blocked_Edge_2Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_edge_2 = /** @type {((inputs?: Practice_Session_Mic_Blocked_Edge_2Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_Edge_2Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zet Microfoon op Toestaan.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réglez Microphone sur Autoriser.")
	return /** @type {LocalizedString} */ ("Set Microphone to Allow.")
});